import { SearchRequest } from 'model/searchRequest';
import { CityToSearch } from 'model/personAccount';
import { GiroWebappError } from 'model/error';
//import { SearchRequest } from 'model/reducers';
import { SearchCitiesTypes } from 'reducer/city/types';
import { Page } from 'services/page';
import { action } from 'typesafe-actions';

export const searchCitiesRequest = (search: SearchRequest) => action(SearchCitiesTypes.SEARCH_CITIES_REQUEST, search);
export const searchCitiesSuccess = (city: Page<CityToSearch>) => action(SearchCitiesTypes.SEARCH_CITIES_SUCCESS, city);
export const searchCitiesError = (error: GiroWebappError) => action(SearchCitiesTypes.SEARCH_CITIES_ERROR, error);
export const searchCitiesResetState = () => action(SearchCitiesTypes.SEARCH_CITIES_RESET_STATE);
